
import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource, bindResource, rpcCrudService } from "kea-resource";
import { CampoRepetidoIdentificacion, ResourceIdentificacionRepetido } from "./identificacion";

const controller = rpcController("SaldosUsuariosZE");


export const SaldosUsuariosZE = cacheResource({

    /** Consulta un listado de SaldosUsuariosZEViewDTO*/
    ConsultarMovimiento: async (filtro?: models.FiltroSaldosUsuariosZE): Promise<models.SaldosUsuariosZEViewDTO[]> => await controller("ConsultarMovimiento", {}, filtro || {}),

    /** Consulta del saldo del usuario de ZE*/
    ObtenerSaldoUsuario: async (idUsuario: number): Promise<number> => await controller("ObtenerSaldoUsuario", { idUsuario }),


}, {
        ConsultarMovimiento: true
    }, {

    });



// WEBPACK FOOTER //
// ./app/resources/items/saldousuariosze.ts